import { render, staticRenderFns } from "./FormProposal.vue?vue&type=template&id=09b5708e&scoped=true&"
import script from "./FormProposal.vue?vue&type=script&lang=js&"
export * from "./FormProposal.vue?vue&type=script&lang=js&"
import style0 from "./FormProposal.vue?vue&type=style&index=0&id=09b5708e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b5708e",
  null
  
)

export default component.exports